import React from 'react';

import {State} from './CardGridState'

import 'font-awesome/css/font-awesome.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import 'flatpickr/dist/flatpickr.min.css';
import "flatpickr/dist/l10n/pl.js"

import '../../../components/grid/styles.scss';
import '../../../components/grid/slickgrid.scss';
import '../../../layouts/gridlayout.css'


import {
  SlickgridReactInstance, 
  GridStateChange, Metrics, Pagination, 
  Column, SlickDataView, Formatter, 
 EditCommand, GridState, EditorValidationResult, GridOption,
} from 'slickgrid-react';
import { SlickCompositeEditorComponent } from '@slickgrid-universal/composite-editor-component';

import i18next, { TFunction } from 'i18next';
import { GridOdataService, OdataServiceApi } from '@slickgrid-universal/odata';
import authService from '../../../services/auth/auth.service';
import { SnackbarKey } from 'notistack';
import { Button } from '@mui/material';
import { GraphqlService, GraphqlServiceApi } from '@slickgrid-universal/graphql';

export const defaultPageSize = 20;

export interface CardGridProps{
  contractor_id:number
}

  const location_note = 'card-note'
  const LOCAL_STORAGE_NOTE_KEY = authService.getCurrentUser()?.shrt + '_crm-' + location_note + '-grid'
  const LOCAL_STORAGE_NOTE_AUTO_EDIT = authService.getCurrentUser()?.shrt + '_crm-' + location_note +  '-auto-edit'
  const LOCAL_STORAGE_NOTE_COLUMN_SIZE = authService.getCurrentUser()?.shrt + '_crm-' + location_note + '-column-size'
  const LOCAL_STORAGE_NOTE_QUERY = authService.getCurrentUser()?.shrt + '_crm-' + location_note + '-query' 

  const location_contact = 'card-contact'
  const LOCAL_STORAGE_CONTACT_KEY = authService.getCurrentUser()?.shrt + '_crm-' + location_contact + '-grid'
  const LOCAL_STORAGE_CONTACT_AUTO_EDIT = authService.getCurrentUser()?.shrt + '_crm-' + location_contact +  '-auto-edit'
  const LOCAL_STORAGE_CONTACT_COLUMN_SIZE = authService.getCurrentUser()?.shrt + '_crm-' + location_contact + '-column-size'
  const LOCAL_STORAGE_CONTACT_QUERY = authService.getCurrentUser()?.shrt + '_crm-' + location_contact + '-query' 

  const location_change = 'card-change'
  const LOCAL_STORAGE_CHANGE_KEY = authService.getCurrentUser()?.shrt + '_crm-' + location_change + '-grid'
  const LOCAL_STORAGE_CHANGE_AUTO_EDIT = authService.getCurrentUser()?.shrt + '_crm-' + location_change +  '-auto-edit'
  const LOCAL_STORAGE_CHANGE_COLUMN_SIZE = authService.getCurrentUser()?.shrt + '_crm-' + location_change + '-column-size'
  const LOCAL_STORAGE_CHANGE_QUERY = authService.getCurrentUser()?.shrt + '_crm-' + location_change + '-query' 



export default class CardGrid extends React.Component<CardGridProps, State>   {
    contractor_id : number;
    storage_note_key!: string;
    auto_edit_note_key!: string ;
    columnsize_note_key!:string;

    storage_contact_key!: string;
    auto_edit_contact_key!: string ;
    columnsize_contact_key!:string;

    storage_change_key!: string;
    auto_edit_change_key!: string ;
    columnsize_change_key!:string;

    query_note_key!:string;
    query_contact_key!:string;
    query_change_key!:string;

    compositeEditorInstanceNote!: SlickCompositeEditorComponent ;
    compositeEditorInstanceContact!: SlickCompositeEditorComponent ;
    compositeEditorInstanceChange!: SlickCompositeEditorComponent ;
    
    noteGrid!: SlickgridReactInstance;
    contactGrid!: SlickgridReactInstance;
    changeGrid!: SlickgridReactInstance;

    protected _commandQueueNote: EditCommand[] = [];
    protected _commandQueueContact: EditCommand[] = [];
    protected _commandQueueChange: EditCommand[] = [];
    
    dataViewObjNote: SlickDataView | undefined;
    dataViewObjContact: SlickDataView | undefined;
    dataViewObjChange: SlickDataView | undefined;

    colorFormatter: Formatter = (_row, _cell, value) => {
        var rtn ={ text: "<div style='width:100%; height:100%; background-color:" + value + "'></div>",  toolTip: value };
        return rtn;
    };

    reactNoteGridReady(reactGrid: SlickgridReactInstance) {
        this.noteGrid = reactGrid; 
        this.dataViewObjNote = reactGrid.dataView;  
         
    }

    reactContactGridReady(reactGrid: SlickgridReactInstance) {
        this.contactGrid = reactGrid; 
        this.dataViewObjNote = reactGrid.dataView;; 
    }

    reactChangeGridReady(reactGrid: SlickgridReactInstance) {
      this.changeGrid = reactGrid; 
      this.dataViewObjChange = reactGrid.dataView;; 
  }

  
    validateCompositeNoteEditors(targetElm: any) {
      var validationResults : EditorValidationResult = { valid: true, msg: "" };
        var currentEditor = this.noteGrid.slickGrid.getCellEditor();
  
        if (currentEditor) {
          validationResults = currentEditor.validate(targetElm);
        }
        return validationResults;
    }

    validateCompositeContactEditors(targetElm: any) {
      var validationResults : EditorValidationResult = { valid: true, msg: "" };
        var currentEditor = this.contactGrid.slickGrid.getCellEditor();
  
        if (currentEditor) {
          validationResults = currentEditor.validate(targetElm);
        }
        return validationResults;
    }

    validateCompositeChangeEditors(targetElm: any) {
      var validationResults : EditorValidationResult = { valid: true, msg: "" };
        var currentEditor = this.changeGrid.slickGrid.getCellEditor();
  
        if (currentEditor) {
          validationResults = currentEditor.validate(targetElm);
        }
        return validationResults;
    }

    constructor(public readonly props: CardGridProps) {

        super(props);
        this.contractor_id = props.contractor_id
        this.auto_edit_note_key = LOCAL_STORAGE_NOTE_AUTO_EDIT //props.auto_edit_key;
        this.storage_note_key = LOCAL_STORAGE_NOTE_KEY //props.storage_key;
        this.columnsize_note_key = LOCAL_STORAGE_NOTE_COLUMN_SIZE
        this.query_note_key = LOCAL_STORAGE_NOTE_QUERY

        this.auto_edit_contact_key = LOCAL_STORAGE_CONTACT_AUTO_EDIT //props.auto_edit_key;
        this.storage_contact_key = LOCAL_STORAGE_CONTACT_KEY //props.storage_key;
        this.columnsize_contact_key = LOCAL_STORAGE_CONTACT_COLUMN_SIZE
        this.query_contact_key = LOCAL_STORAGE_CONTACT_QUERY

        this.auto_edit_change_key = LOCAL_STORAGE_CHANGE_AUTO_EDIT //props.auto_edit_key;
        this.storage_change_key = LOCAL_STORAGE_CHANGE_KEY //props.storage_key;
        this.columnsize_change_key = LOCAL_STORAGE_CHANGE_COLUMN_SIZE
        this.query_change_key = LOCAL_STORAGE_CHANGE_QUERY
     
     
        this.compositeEditorInstanceNote = new SlickCompositeEditorComponent();  
        this.compositeEditorInstanceContact = new SlickCompositeEditorComponent(); 
        this.compositeEditorInstanceChange = new SlickCompositeEditorComponent();
        
        var autoedit_note = true
        if ((localStorage[this.auto_edit_note_key] !==null) && (localStorage[this.auto_edit_note_key] !==undefined)){ 
            autoedit_note = JSON.parse(localStorage[this.auto_edit_note_key]); 
          }

          var autoedit_contact = true
          if ((localStorage[this.auto_edit_contact_key] !==null) && (localStorage[this.auto_edit_contact_key] !==undefined)){ 
              autoedit_contact = JSON.parse(localStorage[this.auto_edit_contact_key]); 
            }

            var autoedit_change = true
            if ((localStorage[this.auto_edit_change_key] !==null) && (localStorage[this.auto_edit_change_key] !==undefined)){ 
                autoedit_change = JSON.parse(localStorage[this.auto_edit_change_key]); 
              }
  

        this.state = {
          notes_gridOptions: undefined,
          notes_columnDefinitions: [],
          notes_dataset: [],
          contacts_gridOptions: undefined,
          contacts_columnDefinitions: [],
          contacts_dataset: [],
          changes_gridOptions: undefined,
          changes_columnDefinitions: [],
          changes_dataset: [],

          notePaginationOptions: undefined,
          contactPaginationOptions: undefined,
          changePaginationOptions: undefined,
          errorStatus: '',
          isCountEnabled: true,
          isSelectEnabled: false,
          isExpandEnabled: false,
          noteMetrics: {} as Metrics,
          contactMetrics: {} as Metrics,
          changeMetrics: {} as Metrics,
          status_note: { class: '', text: '' },
          status_contact: { class: '', text: '' },
          status_change: { class: '', text: '' },
          odataVersion: 4,
          odataQuery: '',
          processing_note: false,
          processing_contact: false,
          processing_change: false,
          isPageErrorTest: false,
          alertWarning: '',
          alertInfo: '',
          alertError: '',
          alertErrorMsg:[],
          isAutoEditNote: autoedit_note,
          isAutoEditContact: autoedit_contact,
          isAutoEditChange: autoedit_change,
          lookupDataNote: [],
          lookupDataContact: [],
          lookupDataChange: [],
          selectedLanguage : 'pl',
          searchQuery : ''
        }; 
      }

      getColumnDefinitions(): Column[] {
        return []
      }
   
      displayNoteSpinner(isProcessing: boolean, isError?: boolean) {
        this.setState((state: State) => ({ ...state, processing_note: isProcessing }));
    
        if (isError) {
          this.setState((state: State) => ({ ...state, status_note: { text: 'ERROR!!!', class: 'alert alert-danger' } }));
        } else {
          this.setState((state: State) => ({
            ...state,
            status_note: (isProcessing)
              ? { text: 'loading', class: 'alert alert-warning' }
              : { text: 'finished', class: 'alert alert-success' }
          }));
        }
      }

      displayContactSpinner(isProcessing: boolean, isError?: boolean) {
        this.setState((state: State) => ({ ...state, processing_contact: isProcessing }));
    
        if (isError) {
          this.setState((state: State) => ({ ...state, status_contact: { text: 'ERROR!!!', class: 'alert alert-danger' } }));
        } else {
          this.setState((state: State) => ({
            ...state,
            status_contact: (isProcessing)
              ? { text: 'loading', class: 'alert alert-warning' }
              : { text: 'finished', class: 'alert alert-success' }
          }));
        }
      }

      displayChangeSpinner(isProcessing: boolean, isError?: boolean) {
        this.setState((state: State) => ({ ...state, processing_cchange: isProcessing }));
    
        if (isError) {
          this.setState((state: State) => ({ ...state, status_change: { text: 'ERROR!!!', class: 'alert alert-danger' } }));
        } else {
          this.setState((state: State) => ({
            ...state,
            status_change: (isProcessing)
              ? { text: 'loading', class: 'alert alert-warning' }
              : { text: 'finished', class: 'alert alert-success' }
          }));
        }
      }

      gridNoteStateChanged(gridStateChanges: GridStateChange) {
        localStorage[this.storage_note_key] = JSON.stringify(gridStateChanges.gridState);  
      }

      gridContactStateChanged(gridStateChanges: GridStateChange) {
        localStorage[this.storage_contact_key] = JSON.stringify(gridStateChanges.gridState);  
      }

      gridChangeStateChanged(gridStateChanges: GridStateChange) {
        localStorage[this.storage_change_key] = JSON.stringify(gridStateChanges.gridState);  
      }
    
    
      customizeHeaderMenu(tmp : Column<any>[], storage_key : string ){
        var key_exist=false;
        if (localStorage[storage_key]){
          var obj = JSON.parse(localStorage[storage_key])
          var dict = new Map(Object.entries(obj));
          key_exist=true;
        }

        tmp.forEach((columnDef) => {
          var col_frozen = false;
          if (key_exist){
          
            var col_width = dict.get(columnDef.field) as number
            if (col_width){
              columnDef.minWidth = col_width
              columnDef.maxWidth = col_width
              col_frozen=true
            }
          }
          columnDef.header = {
            menu: {
              commandItems: [
                {
                  iconCssClass: col_frozen ? 'fa fa-check' : 'fa fa-square', 
                  titleKey: 'Blokada szerokości', // use "title" as plain string OR "titleKey" when using a translation key
                  command: 'save_column',
                  tooltip: 'Zablokuj szerokość kolumny',
                  //cssClass: '',     // container css class
                  //textCssClass: (columnDef.id === 'title' || columnDef.id === 'completed') ? '' : 'blue', // just the text css class
                  positionOrder: 99,
                
                  action: (_e: Event, args: any) => {
                    var dict = new Map();
                    if (localStorage[storage_key]){
                      var obj = JSON.parse(localStorage[storage_key])
                      dict = new Map(Object.entries(obj));
                      var col_width = dict.get(columnDef.field) as number
  
                      if (col_width){
                        localStorage.removeItem(storage_key)
                        dict.delete(columnDef.field)
                        if (storage_key == this.storage_note_key){
                          this.noteGrid.slickGrid.invalidate() 
                        }else if (storage_key == this.storage_contact_key){
                          this.contactGrid.slickGrid.invalidate() 
                        }else if (storage_key == this.storage_change_key){
                          this.contactGrid.slickGrid.invalidate() 
                        }
                      }else{
                        dict.set(args.column.field, args.column.width);
                        
                      }
                      localStorage[storage_key] = JSON.stringify(Object.fromEntries(dict))
                    }else{
                      dict.set(args.column.field, args.column.width);
                      localStorage[storage_key] = JSON.stringify(Object.fromEntries(dict))
                    }
                    
                  
                    
                  }
                },
              
              ]
            }
          }
        });
        return tmp;
      }

      cancelNoteFiltering(){
          this.noteGrid.filterService.updateFilters([]); 	
           window.location.reload()


      }
      

      setNoteFactorySettings(){
        localStorage.removeItem(this.columnsize_note_key)
        this.noteGrid.gridService.resetGrid(this.getColumnDefinitions());
        //this.reactGrid.paginationService!.changeItemPerPage(defaultPageSize);
    
        this.setState((state: State, props: CardGridProps) => ({
          ...state,
          isAutoEditNote:true,
        }));
    
        setTimeout(() => localStorage.removeItem(this.storage_note_key));
        setTimeout(() => localStorage.removeItem(this.auto_edit_note_key));
        
        window.location.reload();
    
      }

      setContactFactorySettings(){
        localStorage.removeItem(this.columnsize_contact_key)
        this.contactGrid.gridService.resetGrid(this.getColumnDefinitions());

        this.setState((state: State, props: CardGridProps) => ({
          ...state,
          isAutoEditContact:true,
        }));
    
        setTimeout(() => localStorage.removeItem(this.storage_contact_key));
        setTimeout(() => localStorage.removeItem(this.auto_edit_contact_key));
        
        window.location.reload();
    
      }

      setChangeFactorySettings(){
        localStorage.removeItem(this.columnsize_change_key)
        this.changeGrid.gridService.resetGrid(this.getColumnDefinitions());

        this.setState((state: State, props: CardGridProps) => ({
          ...state,
          isAutoEditChange:true,
        }));
    
        setTimeout(() => localStorage.removeItem(this.storage_change_key));
        setTimeout(() => localStorage.removeItem(this.auto_edit_change_key));
        
        window.location.reload();
    
      }
    
      throwNotePageChangeError() {
        this.setState(
          (state: State) => ({ ...state, isPageErrorTest: true }),
          () => this.noteGrid?.paginationService?.goToLastPage()
        );
      }

      throwContactPageChangeError() {
        this.setState(
          (state: State) => ({ ...state, isPageErrorTest: true }),
          () => this.contactGrid?.paginationService?.goToLastPage()
        );
      }

      throwChangePageChangeError() {
        this.setState(
          (state: State) => ({ ...state, isPageErrorTest: true }),
          () => this.changeGrid?.paginationService?.goToLastPage()
        );
      }

      autoeditNotechange(data:any){
        this.setState((state: State, props: CardGridProps) => ({
          ...state,
          isAutoEditNote:data,
        }));
    
        this.noteGrid.slickGrid.setOptions({autoEdit:data})
        localStorage[this.auto_edit_note_key] = JSON.stringify(data);
      }    

      autoeditContactchange(data:any){
        this.setState((state: State, props: CardGridProps) => ({
          ...state,
          isAutoEditContact:data,
        }));
    
        this.contactGrid.slickGrid.setOptions({autoEdit:data})
        localStorage[this.auto_edit_contact_key] = JSON.stringify(data);
      }   

      autoeditChangechange(data:any){
        this.setState((state: State, props: CardGridProps) => ({
          ...state,
          isAutoEditChange:data,
        }));
    
        this.changeGrid.slickGrid.setOptions({autoEdit:data})
        localStorage[this.auto_edit_change_key] = JSON.stringify(data);
      }   
      
      
      
      getGridDefinition(state: State): GridOption {
          
        return {
            autoCommitEdit: false,
            editable: true,
            enableAutoResize: true,
            enableAddRow:true,
            enableGridMenu : true,
            customFooterOptions: {
              metricTexts: {
                itemsKey: 'ITEMS',
                ofKey: 'OF',
                lastUpdateKey: 'LAST_UPDATE',
              },
              dateFormat: 'YYYY-MM-DD hh:mm a',
              hideTotalItemCount: false,
              hideLastUpdateTimestamp: false,
            },
            gridMenu: {
              commandTitle: 'Polecenia',
              columnTitle: ' ',
              iconCssClass: 'fa fa-ellipsis-v',
              menuWidth: 17,
              resizeOnShowHeaderRow: true,
    
              commandItems: [
                {command: 'best-fit', title : 'Dopasuj kolumny', positionOrder: 98},
               
                {
                  command: 'export', title: 'Export', positionOrder: 99,
                 
                  commandItems: [
                    { command: 'exports-txt', title: 'Text (tab delimited)' },
                    {
                       command: 'sub-menu', title: 'Excel', cssClass: 'green', subMenuTitle: 'Dostępne formaty', subMenuTitleCssClass: 'text-italic orange',
                       commandItems: [
                         { command: 'exports-csv', title: 'Excel (csv)' },
                         { command: 'exports-xlsx', title: 'Excel (xlsx)' },
                      ]
                    }
                  ]
                },
              ],
    
              
            
              onCommand: (e, args) => {
                if (args.command === 'best-fit') {
                  this.noteGrid.resizerService.resizeGrid()
                }
              }
            },           
            headerMenu: {
              hideColumnHideCommand : true,            
            },
            compositeEditorOptions : {
              labels : {
                cancelButton: "Anuluj",
                cloneButton: "Kopiuj",
                massSelectionButton: "Zaktualizuj wybrane",
                resetEditorButtonTooltip: "Cofnij zmianę",
                resetFormButton: "Cofnij zmiany",
                
                saveButton: 'Zapisz'
              }
            },
        
            autoResize: {
                container: '#smaller-container',
                rightPadding: 10,
                bottomPadding:70
            },
            checkboxSelector: {
                hideInFilterHeaderRow: false,
                hideInColumnTitleRow: true
            },
            enableCompositeEditor:true,
            enableCellNavigation: true,
            enableFiltering: true,
            enableCheckboxSelector: true,
            enableRowSelection: true,
            enablePagination: true, // you could optionally disable the Pagination
            pagination: {
                pageSizes: [10, 20, 50, 100, 500, 1000, 2000, 50000],
                pageSize: defaultPageSize,
                totalItems: 0
            },
            backendServiceApi: {
                service: new GridOdataService(),
                options: {
                    enableCount: state.isCountEnabled, // add the count in the OData query, which will return a property named "__count" (v2) or "@odata.count" (v4)
                    enableSelect: state.isSelectEnabled,
                    enableExpand: state.isExpandEnabled,
                    version: state.odataVersion        // defaults to 2, the query string is slightly different between OData 2 and 4
              
                },               
          } as OdataServiceApi
            
        };
      }

      

}